import React, { FC } from 'react';
import { Button, Card, CardBody, Row } from 'reactstrap';

import Page from 'views/Layout/Pages/Page';

const functionThatThrowsError = () => {
  throw new Error('Test Error');
};

const SentryTest: FC = () => {
  const [showFaultySubcomponent, setShowFaultySubcomponent] =
    React.useState(false);

  const functionThatThrowsErrorInComponent = React.useCallback(() => {
    setShowFaultySubcomponent(true);
  }, []);

  return (
    <Page title={'Sentry Test'}>
      <Card>
        <CardBody>
          <Row>
            <Button color="light" onClick={functionThatThrowsError}>
              {'Thow error from function'}
            </Button>
          </Row>
          <Row className="mt-3">
            <Button color="light" onClick={functionThatThrowsErrorInComponent}>
              {'Thow error in react component'}
            </Button>
          </Row>
          {showFaultySubcomponent && <FaultyComponent />}
        </CardBody>
      </Card>
    </Page>
  );
};

const FaultyComponent: FC = () => {
  throw new Error('Subcomponent Test Error');
};

export default SentryTest;
